import { render, staticRenderFns } from "./ContentSelector.vue?vue&type=template&id=24ba6850&scoped=true&"
import script from "./ContentSelector.vue?vue&type=script&lang=js&"
export * from "./ContentSelector.vue?vue&type=script&lang=js&"
import style0 from "./ContentSelector.vue?vue&type=style&index=0&id=24ba6850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba6850",
  null
  
)

export default component.exports